import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text, useOpenModal } from '@modusign/design-system';

import { Label, LabelInfoModal } from '@app/features/label';

export default function TemplateLabelListItem({
  label,
  onDelete,
}: {
  label: Label;
  onDelete: (labelId: string) => void;
}) {
  const openModal = useOpenModal();
  return (
    <Flex
      as="li"
      bg="buttonBackgroundNeutralBase"
      border="1px solid"
      borderColor="buttonBorderNeutralBase"
      borderRadius="3px"
      key={label.id}
      px={4}
      py={3}
      width="100%"
    >
      <Text
        color="textNeutralBase"
        ellipsis
        fontSize="xs"
        fontWeight="medium"
        mr={3}
        sx={{
          flex: 'auto',
          overflow: 'hidden',
          '&:hover': {
            cursor: 'pointer',
            textDecoration: 'underline',
          },
        }}
        onClick={() => {
          openModal(({ onClose }) => <LabelInfoModal id={label.id} onClose={onClose} />);
        }}
      >
        {label.name}
      </Text>
      <Box as="button" color="textNeutralLight" onClick={() => onDelete(label.id)}>
        <FontAwesomeIcon icon={faXmark} />
      </Box>
    </Flex>
  );
}
